import { z } from 'zod';

export const federalStateLoginSchema = z.object({
  idFederalStateLogin: z.number().default(-1),
  idFederalState: z.number().default(-1),
  Notary_idUser: z.number().default(-1),
  Username: z.string().default(''),
  Password: z.string().default(''),
  isFirstStage: z
    .union([z.boolean(), z.number().transform(val => Boolean(val))])
    .transform(val => Boolean(val))
    .default(false),
  SecondName: z.string().nullable().default(null),
  Parent_idFederalStateLogin: z.number().nullable().default(null),
  // Zuordnung zu Mitarbeitern/Gruppen (zusätzlich zum Notar)
  UserArray: z.array(z.number()).default([]),
  UserGroupArray: z.array(z.number()).default([]),
  // Aus Relationen
  FederalState: z.string().optional(),
});

export type IFederalStateLogin = z.infer<typeof federalStateLoginSchema>;
